import React from "react";
import { Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Form from "./pages/Form";
import Booking from "./pages/Booking";
import ThankYou from "./pages/ThankYou";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/form" element={<Form />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/thank-you" element={
            <ProtectedRoute>
              <ThankYou />
            </ProtectedRoute>
          } />
        </Routes>
        <Analytics />
      </div>
    </AuthProvider>
  );
};

export default App; 